export const HEADERS_KEYS = {
  EVENT_TRACE_ID: "x-event-trace-id",
} as const;
